export default __webpack_public_path__ + "static/media/riverTubing2.870ad951.webp";